<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import SetPasswordForm from '@/components/Auth/SetPasswordForm.vue'
import { useNoReferrerMeta } from '@/composables/useNoReferrerMeta'

setPageTitle(PageMeta.Auth.setPassword.title)
definePage({ meta: PageMeta.Auth.setPassword.meta })
useNoReferrerMeta()
</script>

<template>
  <SetPasswordForm />
</template>
